import { combineReducers } from "redux";
import NavMenu from "./reducer";

export default combineReducers({
  NavMenuState: NavMenu,
});
